// extracted by mini-css-extract-plugin
module.exports = {"faqpagetext":"faqpagetext--MhbZl","resourcestabs":"resourcestabs--rDt-h","titletabpane":"titletabpane--omirj"};